export default __webpack_public_path__ + "tabComponent.svg";